const points = [
  "L'anti-fausse manœuvre bloque l'ouverture oscillante si la fenêtre est mal fermée",
  "Il se dérègle avec l'usure et reste en position bloquée même si la fenêtre est fermée",
  "Le compas de manœuvre guide le mouvement d'inclinaison et peut être tordu ou usé",
  "Un compas détaché ou rouillé empêche toute ouverture en oscillation",
  "La pièce doit être réajustée ou remplacée pour rétablir le double mouvement",
];

export default function AntiFausseManoeuvre() {
  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Les mécanismes de blocage
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-6 leading-tight">
            Anti-fausse manœuvre et <span className="font-serif italic">compas</span>
          </h2>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-8">
            L'anti-fausse manœuvre est un dispositif de sécurité obligatoire sur les fenêtres oscillo-battant. Son rôle : empêcher la bascule vers la position oscillante si le battant n'est pas complètement fermé. Quand ce système fonctionne mal, il se bloque dans la mauvaise position et la fenêtre reste coincée en oscillation ou ne peut plus du tout basculer. Le compas de manœuvre est le bras articulé qui guide la fenêtre en position inclinée. Avec le temps, ses charnières s'usent, la visserie se détend, et le mouvement devient impossible. Nous intervenons sur ces deux mécanismes chez vous, en une seule visite.
          </p>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-8">
            Les marques de fenêtres utilisent des systèmes différents : Ferco a une cale à repositionner, GU utilise un compas à réengager, Maco a un verrou de sécurité spécifique. Nos techniciens connaissent chaque système et ont les pièces de remplacement en stock. Nous débloquons d'abord la fenêtre, puis réparons le mécanisme pour éviter le blocage récurrent.
          </p>
          <div className="space-y-4">
            {points.map((p, i) => (
              <div key={i} className="flex items-start gap-4 bg-white rounded-2xl border border-rose-200 p-5 md:p-6">
                <div className="w-8 h-8 rounded-full bg-coral/10 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-check-line text-coral text-sm" />
                </div>
                <span className="text-plum-dark font-medium text-sm md:text-base">{p}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}